import React, { useState } from "react";

import { postResendEmailVerification } from "../../../../api/accounts";
import { firebaseSignIn } from "../../../../firebase/helper";
import optiumLogo from "../../../../images/optium_logo.svg";

import { getAPIErrorDetailOrMessage } from "@/api/helpers";
import { translation } from "@/i18n";
import { nsAuth } from "@/i18n/locales/auth";
import {
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
} from "@fluentui/react-components";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { LanguageSelectLoginDropdown } from "../../../LanguageSelect/LanguageSelectLoginDropdown";
import styles from "./index.module.css";

const useTranslation = translation.use(nsAuth);

/**
 * @description email検証を促す
 */
export const ResendEmailVerification: React.FC<{ idp_uid: string }> = ({
  idp_uid,
}) => {
  const { t } = useTranslation();
  const [isApiProcessing, setIsAPIProcessing] = useState(false);
  const [messageIntent, setMessageIntent] = useState<
    "success" | "error" | null
  >(null);
  const [errorMessage, setErrorMesssage] = useState<string | null>(null);

  const handleResendEmailVerification = async () => {
    setMessageIntent(null);
    setIsAPIProcessing(true);
    try {
      await postResendEmailVerification({
        idp_uid,
      });
      setMessageIntent("success");
    } catch (error) {
      const { errorMessage } = getAPIErrorDetailOrMessage(error);
      setMessageIntent("error");
      setErrorMesssage(errorMessage);
    } finally {
      setIsAPIProcessing(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.languageSelect}>
        <LanguageSelectLoginDropdown />
      </div>
      <div className={styles.contentBox}>
        <div className={styles.logo}>
          <img src={optiumLogo} height={28} alt="OPTIUM" />
        </div>
        <div className={styles.message}>
          {t.auth.emailVerification.instruction()}
        </div>
        {messageIntent === "success" && (
          <MessageBar intent="success" className={styles.messageWrapper}>
            <MessageBarBody className={styles.message}>
              {t.auth.emailVerification.resendSuccess()}
            </MessageBarBody>
            <MessageBarActions
              containerAction={
                <Button
                  aria-label={t.auth.emailVerification.dismissLabel()}
                  appearance="transparent"
                  icon={<Dismiss20Regular />}
                  onClick={() => setMessageIntent(null)}
                />
              }
            />
          </MessageBar>
        )}
        {messageIntent === "error" && (
          <MessageBar intent="error" className={styles.messageWrapper}>
            <MessageBarBody className={styles.message}>
              {t.auth.emailVerification.resendError({
                detail: errorMessage ?? "",
              })}
            </MessageBarBody>
            <MessageBarActions
              containerAction={
                <Button
                  aria-label={t.auth.emailVerification.dismissLabel()}
                  appearance="transparent"
                  icon={<Dismiss20Regular />}
                  onClick={() => setMessageIntent(null)}
                />
              }
            />
          </MessageBar>
        )}
        <div className={styles.buttons}>
          <Button
            className={styles.button}
            onClick={handleResendEmailVerification}
            disabled={isApiProcessing}
          >
            {t.auth.emailVerification.resendButton()}
          </Button>
          <Button
            className={styles.button}
            onClick={async () => {
              await firebaseSignIn({ isReplaceHistory: true });
            }}
            disabled={isApiProcessing}
          >
            {t.auth.emailVerification.reloginButton()}
          </Button>
          <Button
            className={styles.button}
            onClick={() => {
              // @ts-ignore
              window.signOut();
            }}
          >
            {t.auth.emailVerification.logoutButton()}
          </Button>
        </div>
      </div>
    </div>
  );
};
